/**
 * Script para processamento de tags com formato "Subtítulo|Título"
 */
document.addEventListener('DOMContentLoaded', function() {
    // Processa o cabeçalho da tag em post.hbs
    formatPostTagHeader();
    
    // Processa o cabeçalho da tag em tag.hbs
    formatTagPageHeader();
    
    // Verificar imediatamente para evitar flashes de conteúdo
    checkForVideoAndHandleFeatureImage();
    
    // Configurar verificação repetida com delay para garantir carregamento completo
    setTimeout(checkForVideoAndHandleFeatureImage, 500);
    setTimeout(checkForVideoAndHandleFeatureImage, 1500);
    
    // Configurar MutationObserver para monitorar mudanças no conteúdo
    setupContentObserver();
    
    // Formatar tags com separador |
    formatTagsWithSeparator();

    // Expor a função formatTagsWithSeparator globalmente para uso pelo infinite scroll
    window.formatTagsWithSeparator = formatTagsWithSeparator;
    
    // Patch para a função pagination
    patchPaginationFunction();
    
    // Configurar observador para novos posts carregados (fallback)
    setupInfiniteScrollObserver();
});

/**
 * Formata o cabeçalho da tag em post.hbs
 */
function formatPostTagHeader() {
    const container = document.getElementById('tag-title-container');
    if (!container) return;
    
    const tagName = container.getAttribute('data-tag-name');
    const tagUrl = container.getAttribute('data-tag-url');
    
    if (tagName && tagName.includes('|')) {
        const parts = tagName.split('|');
        const subtitle = parts[0].trim();
        const title = parts[1].trim();
        
        // Substituir o conteúdo original do container
        container.innerHTML = `
            <h3 class="gh-tag-post-list-subtitle">${subtitle}</h3>
            <a href="${tagUrl}" class="gh-article-tag-title-link">
                <h2 class="gh-article-tag-title">${title}</h2>
            </a>
        `;
    }
}

/**
 * Formata o cabeçalho da tag em tag.hbs
 */
function formatTagPageHeader() {
    const container = document.getElementById('tag-header-container');
    if (!container) return;
    
    const tagName = container.getAttribute('data-tag-name');
    const tagDescription = container.getAttribute('data-tag-description');
    const hasImage = container.getAttribute('data-has-image') === 'true';
    const featureImage = container.getAttribute('data-feature-image');
    const featureImageAlt = container.getAttribute('data-feature-image-alt');
    
    let title = tagName;
    let subtitle = '';
    
    // Verificar se o nome da tag contém um pipe
    if (tagName && tagName.includes('|')) {
        const parts = tagName.split('|');
        subtitle = parts[0].trim();
        title = parts[1].trim();
    }
    
    // Criar o HTML do cabeçalho no formato do componente category-header
    container.innerHTML = `
        <div class="gh-category-header gh-container${hasImage ? ' has-image' : ''}" style="display: block;">
            <div class="gh-container-inner gh-inner">
                <div class="gh-category-header-content">
                    <div class="gh-tag-post-list-header">
                        <div class="gh-tag-post-list-title-container">
                            ${subtitle ? `<h3 class="gh-tag-post-list-subtitle">${subtitle}</h3>` : ''}
                            <h2 class="gh-tag-post-list-title">${title}</h2>
                        </div>
                        ${tagDescription ? `<p class="gh-tag-post-list-description">${tagDescription}</p>` : ''}
                    </div>
                    ${hasImage ? `
                        <figure class="gh-category-feature-image">
                            <img
                                srcset="${featureImage} 300w,
                                       ${featureImage} 600w,
                                       ${featureImage} 1000w,
                                       ${featureImage} 2000w"
                                sizes="(max-width: 1200px) 100vw, 1200px"
                                src="${featureImage}"
                                alt="${featureImageAlt}"
                                loading="lazy"
                            >
                        </figure>
                    ` : ''}
                </div>
            </div>
        </div>
    `;
}

/**
 * Nova abordagem simplificada para verificar vídeos e gerenciar a feature image
 */
function checkForVideoAndHandleFeatureImage() {
    console.log('[Bombarco] Verificando feature image vs. vídeo...');
    
    // Primeira coisa: garantir que a imagem esteja visível por padrão
    let featureImageContainer = document.querySelector('.gh-feature-image-container');
    if (!featureImageContainer) {
        // Tenta o seletor antigo como fallback
        const oldFeatureImage = document.querySelector('.gh-article-image');
        if (!oldFeatureImage) {
            console.log('[Bombarco] Nenhuma feature image encontrada.');
            return;
        }
        
        // Se encontrou o antigo, usa-o
        console.log('[Bombarco] Usando seletor antigo para feature image');
        featureImageContainer = oldFeatureImage.parentElement;
    }
    
    // Tornar a imagem visível por padrão
    featureImageContainer.style.display = 'block';
    
    // Obter o contêiner de conteúdo
    const contentContainer = document.querySelector('.gh-content');
    if (!contentContainer) {
        console.log('[Bombarco] Contêiner de conteúdo não encontrado.');
        return;
    }
    
    // Verificar se o primeiro elemento significativo é um vídeo
    const firstChildElements = Array.from(contentContainer.children);
    
    if (firstChildElements.length === 0) {
        console.log('[Bombarco] Contêiner de conteúdo vazio.');
        return;
    }
    
    const firstElement = firstChildElements[0];
    console.log('[Bombarco] Primeiro elemento do conteúdo:', firstElement.tagName, 
                firstElement.classList ? Array.from(firstElement.classList) : 'sem classes');
    
    // Verificar se o primeiro elemento é ou contém um vídeo
    let isFirstElementVideo = false;
    
    // Verificar se o próprio elemento é vídeo
    if (firstElement.tagName === 'IFRAME' || 
        firstElement.tagName === 'VIDEO' ||
        (firstElement.classList && 
         (firstElement.classList.contains('kg-embed-card') ||
          firstElement.classList.contains('kg-video-card') ||
          firstElement.classList.contains('kg-oembed-card') ||
          firstElement.classList.contains('kg-youtube-card') ||
          firstElement.classList.contains('kg-vimeo-card') ||
          firstElement.classList.contains('video-card')))) {
        isFirstElementVideo = true;
    }
    
    // Verificar se é uma figura com vídeo/iframe
    if (firstElement.tagName === 'FIGURE' && 
        (firstElement.querySelector('iframe') || firstElement.querySelector('video'))) {
        isFirstElementVideo = true;
    }
    
    // Verificar se contém algum elemento de vídeo diretamente
    if (firstElement.querySelector('iframe') || firstElement.querySelector('video')) {
        isFirstElementVideo = true;
    }
    
    console.log('[Bombarco] O primeiro elemento é um vídeo?', isFirstElementVideo);
    
    if (isFirstElementVideo) {
        console.log('[Bombarco] Escondendo feature image porque o primeiro elemento é um vídeo.');
        featureImageContainer.style.display = 'none';
        
        // Adicionar classe ao body para debugging
        document.body.classList.add('has-video-as-first-element');
    } else {
        console.log('[Bombarco] Mantendo feature image porque o primeiro elemento não é um vídeo.');
        featureImageContainer.style.display = 'block';
        // Adicionar classe ao body para debugging
        document.body.classList.add('no-video-as-first-element');
    }
}

/**
 * Configura um observador para monitorar mudanças no conteúdo
 */
function setupContentObserver() {
    const contentContainer = document.querySelector('.gh-content');
    if (!contentContainer) {
        console.log('[Bombarco] Não foi possível configurar o observador: contêiner de conteúdo não encontrado');
        return;
    }
    
    // Configurar o observador para reagir a mudanças no DOM
    const observer = new MutationObserver((mutations) => {
        console.log('[Bombarco] Mudanças detectadas no conteúdo, verificando feature image vs. vídeo novamente');
        checkForVideoAndHandleFeatureImage();
    });
    
    // Iniciar observação
    observer.observe(contentContainer, { 
        childList: true,     // Observar adições/remoções diretas de filhos
        subtree: true,       // Observar mudanças em toda a árvore de descendentes
        characterData: true, // Observar mudanças no conteúdo de texto
        attributes: true     // Observar mudanças de atributos
    });
    
    console.log('[Bombarco] Observador de conteúdo configurado com sucesso');
}

/**
 * Formata tags que contêm o formato "Categoria|Subcategoria" para mostrar apenas a subcategoria
 */
function formatTagsWithSeparator() {
    // Formata as tags que aparecem no rodapé dos cards
    const tagsClasses = [
        '.gh-card-tag',
        '.gh-tag-carousel-card-tag',
        '.gh-tag-title'
    ];

    tagsClasses.forEach(className => {
        document.querySelectorAll(className).forEach(tag => {
            const text = tag.textContent.trim();
            if (text.includes('|')) {
            const parts = text.split('|');
            tag.textContent = parts[1].trim();
        }

            tag.style.display = "flex";
        });
    });

    // Formata cabeçalhos de tag em outros lugares
    document.querySelectorAll('.gh-tag-title').forEach(title => {
        const text = title.textContent.trim();
        if (text.includes('|')) {
            const parts = text.split('|');
            title.textContent = parts[1].trim();
        }
    });
}

/**
 * Formata tags em elementos específicos
 * @param {Array} elements - Array de elementos DOM para processar
 */
function formatTagsInNewElements(elements) {
    if (!elements || elements.length === 0) return;
    
    elements.forEach(element => {
        // Processa tags dentro do elemento
        const tags = element.querySelectorAll('.gh-card-tag, .gh-tag-carousel-card-tag, .gh-tag-title');
        
        tags.forEach(tag => {
            const text = tag.textContent.trim();
            if (text.includes('|')) {
                const parts = text.split('|');
                tag.textContent = parts[1].trim();
            }
            
            tag.style.display = "flex";
        });
    });
}

/**
 * Modifica a função pagination para chamar formatTagsInNewElements após carregar novos posts
 */
function patchPaginationFunction() {
    // Verifica se a função pagination está disponível
    if (typeof window.pagination !== 'function') {
        setTimeout(patchPaginationFunction, 500);
        return;
    }

    
    // Guarda a referência original da função
    const originalPagination = window.pagination;
    
    // Sobrescreve a função pagination
    window.pagination = function(isInfinite = true, done, isMasonry = false) {
        // Cria uma função de callback modificada que formata as tags após carregar os novos elementos
        const modifiedDone = function(elements, loadNextWithCheck) {
            // Formata as tags nos novos elementos
            formatTagsInNewElements(elements);
            
            // Chama o callback original, se existir
            if (typeof done === 'function') {
                done(elements, loadNextWithCheck);
            }
        };
        
        // Chama a função pagination original com o novo callback
        return originalPagination(isInfinite, modifiedDone, isMasonry);
    };
    
    console.log('[Bombarco] Função pagination modificada com sucesso');
}

/**
 * Configura um observador para monitorar novos posts carregados pelo infinite scroll
 * Este é um fallback caso o patch na função pagination não funcione
 */
function setupInfiniteScrollObserver() {
    const feedContainer = document.querySelector('.gh-feed');
    if (!feedContainer) {
        console.log('[Bombarco] Container de feed não encontrado para observar novos posts');
        return;
    }
    
    console.log('[Bombarco] Configurando observador para novos posts carregados pelo infinite scroll');
    
    // Conjunto para rastrear elementos já processados
    const processedElements = new WeakSet();
    
    // Configurar o observador
    const observer = new MutationObserver((mutations) => {
        mutations.forEach(mutation => {
            if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                // Processar apenas novos artigos
                mutation.addedNodes.forEach(node => {
                    if (node.nodeType === Node.ELEMENT_NODE && 
                        !processedElements.has(node) && 
                        (node.classList.contains('gh-card') || node.querySelector('.gh-card'))) {
                        
                        // Marcar o elemento como processado
                        processedElements.add(node);
                        
                        // Processar tags no novo artigo
                        const tagsToProcess = node.querySelectorAll('.gh-card-tag, .gh-tag-carousel-card-tag, .gh-tag-title');
                        
                        if (tagsToProcess.length > 0) {
                            console.log('[Bombarco] Processando tags em novo artigo adicionado:', tagsToProcess.length);
                            
                            tagsToProcess.forEach(tag => {
                                const text = tag.textContent.trim();
                                if (text.includes('|')) {
                                    const parts = text.split('|');
                                    tag.textContent = parts[1].trim();
                                }
                                
                                tag.style.display = "flex";
                            });
                        }
                    }
                });
            }
        });
    });
    
    // Iniciar observação
    observer.observe(feedContainer, { 
        childList: true,     // Observar adições/remoções diretas de filhos
        subtree: true        // Observar mudanças em toda a árvore de descendentes
    });
    
    console.log('[Bombarco] Observador de infinite scroll configurado com sucesso');
} 